import { NavigateFunction } from "react-router-dom";

const REDIRECT_KEY = "auth_redirect_url";

export const handleAuthRedirect = (
  user: any,
  initialized: boolean | undefined,
  pathname: string,
  navigate: NavigateFunction,
  search?: string
) => {
  if (!initialized) return;

  // Public paths that don't require authentication
  const publicPaths = ["/login", "/register"];
  const isPublicPath = publicPaths.includes(pathname);

  // If not logged in and trying to access a protected route, redirect to login
  if (!user && !isPublicPath) {
    // Save the intended destination so we can restore it after login
    const fullPath = search ? `${pathname}${search}` : pathname;
    sessionStorage.setItem(REDIRECT_KEY, fullPath);
    navigate("/login", { replace: true });
    return;
  }

  // If logged in and trying to access login/register, redirect to saved URL or main app
  if (user && isPublicPath) {
    const savedRedirect = sessionStorage.getItem(REDIRECT_KEY);
    sessionStorage.removeItem(REDIRECT_KEY);
    navigate(savedRedirect || "/", { replace: true });
  }
};
